import { FI_STORAGE_KEY, } from "./FulfillmentInstructionSerialization";
import { FulfillmentInstructionsStorageManager } from "./FulfillmentInstructionsStorageManager";
export class FulfillmentInstructionsAfterPurchaseStorageManager {
    constructor(data) {
        this.data = data;
        this.fulfillmentInstructionsStorageManager =
            new FulfillmentInstructionsStorageManager(data);
    }
    store() {
        if (this.data.type === "QrWaiter") {
            return;
        }
        const fulfillmentInstructionsData = {};
        const fulfilmentInstructionsDataString = JSON.stringify(fulfillmentInstructionsData);
        localStorage.setItem(FI_STORAGE_KEY, fulfilmentInstructionsDataString);
    }
    restore() {
        this.fulfillmentInstructionsStorageManager.restore();
    }
}
